import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";

const CheckoutAddress = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    fullName: "",
    mobile: "",
    pincode: "",
    address: "",
    locality: "",
    city: "",
    state: "",
    addressType: "Home",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };


  const handleSaveAddress = async () => {
    if (
      !form.fullName ||
      !form.mobile ||
      !form.pincode ||
      !form.address ||
      !form.city ||
      !form.state
    ) {
      alert("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      if (!token) {
        alert("Please login first");
        navigate("/login");
        return;
      }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/address`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      localStorage.setItem("selectedAddress", res.data._id);

      alert("Address saved successfully");
      navigate("/checkout/payment");
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };




  const handleWhatsAppOrder = () => {
  if (
    !form.fullName ||
    !form.mobile ||
    !form.pincode ||
    !form.address ||
    !form.city ||
    !form.state
  ) {
    alert("Please fill all required fields");
    return;
  }

  const cart = JSON.parse(localStorage.getItem("cart")) || [];

  if (cart.length === 0) {
    alert("Your cart is empty");
    return;
  }

  const total = cart.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const itemsText = cart
    .map(
      (item) =>
        `${item.name} x ${item.quantity} - ₹${item.price * item.quantity}`
    )
    .join("%0A");

  const message = `
New Order 🛒

Name: ${form.fullName}
Mobile: ${form.mobile}
Address: ${form.address}, ${form.locality}, ${form.city}, ${form.state} - ${form.pincode}

Items:
${itemsText}

Total: ₹${total}
`;

  const phoneNumber = "919834704067"; 
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  window.open(whatsappURL, "_blank");
};

  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 md:px-10 pt-28">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8">

          <h2 className="text-xl md:text-2xl font-semibold mb-6">
            Add Delivery Address
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={form.fullName}
              onChange={handleChange}
              className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-black"
            />

            <input
              type="text"
              name="mobile"
              placeholder="Mobile Number"
              value={form.mobile}
              onChange={handleChange}
              className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-black"
            />

            <input
              type="text"
              name="pincode"
              placeholder="Pincode"
              value={form.pincode}
              onChange={handleChange}
              className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-black"
            />

            <input
              type="text"
              name="locality"
              placeholder="Locality"
              value={form.locality}
              onChange={handleChange}
              className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-black"
            />
          </div>

          <textarea
            name="address"
            placeholder="Full Address"
            value={form.address}
            onChange={handleChange}
            rows="3"
            className="border rounded-lg px-4 py-3 w-full mt-4 focus:ring-2 focus:ring-black"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <input
              type="text"
              name="city"
              placeholder="City"
              value={form.city}
              onChange={handleChange}
              className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-black"
            />

            <input
              type="text"
              name="state"
              placeholder="State"
              value={form.state}
              onChange={handleChange}
              className="border rounded-lg px-4 py-3 focus:ring-2 focus:ring-black"
            />
          </div>

          <div className="mt-6">
            <p className="font-medium mb-2">Address Type</p>
            <div className="flex gap-4">
              {["Home", "Work"].map((type) => (
                <button
                  key={type}
                  type="button"
                  onClick={() => setForm({ ...form, addressType: type })}
                  className={`px-6 py-2 rounded-full border ${
                    form.addressType === type
                      ? "bg-black text-white"
                      : "bg-white text-black"
                  }`}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>

       <div className="mt-8 space-y-4">

  {/* Save Address Button */}
  <button
    onClick={handleSaveAddress}
    disabled={loading}
    className="w-full bg-black text-white py-3 rounded-xl 
               hover:bg-gray-900 transition-all duration-300 
               disabled:opacity-50 disabled:cursor-not-allowed"
  >
    {loading ? "Saving..." : "Save & Deliver Here"}
  </button>

  {/* WhatsApp Order Button */}
  <button
    onClick={handleWhatsAppOrder}
    className="w-full bg-green-500 hover:bg-green-600 
               text-white py-3 rounded-xl 
               transition-all duration-300 
               flex items-center justify-center gap-3"
  >
    <FaWhatsapp className="text-xl" />
    <span className="font-medium">Order on WhatsApp</span>
  </button>

</div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutAddress;